import React from 'react';

const OrganicBlob = ({
  color = '#c1ff72',
  size = 400,
  style = {},
  variant = 1,
  opacity = 0.3,
  className = ''
}) => {
  // Different blob path variants for variety
  const blobPaths = {
    1: "M45.3,-51.2C58.5,-41.5,69,-26.4,71.8,-10.1C74.5,6.2,69.5,23.7,59.4,37.3C49.3,50.9,34.1,60.6,17.1,66.1C0.1,71.6,-18.7,72.9,-34.8,66.4C-50.9,59.9,-64.3,45.6,-71.1,28.6C-77.9,11.6,-78.1,-8.1,-71.4,-24.8C-64.7,-41.5,-51.1,-55.2,-36,-62.4C-20.9,-69.6,-4.3,-70.3,10.7,-66.1C25.7,-61.9,32.1,-60.9,45.3,-51.2Z",
    2: "M39.5,-47.5C52.1,-37.8,64.1,-26.3,68.4,-12.1C72.7,2.1,69.3,19,60.8,32.8C52.3,46.6,38.7,57.3,23.3,62.4C7.9,67.5,-9.3,67,-24.9,61.2C-40.5,55.4,-54.5,44.3,-62.3,29.8C-70.1,15.3,-71.7,-2.6,-66.8,-18.3C-61.9,-34,-50.5,-47.5,-37.1,-57.1C-23.7,-66.7,-8.3,-72.4,3.6,-76.7C15.5,-81,26.9,-57.2,39.5,-47.5Z",
    3: "M44.7,-52.8C57.3,-44.2,66.4,-29.6,69.5,-13.8C72.6,2,69.7,19,61.3,32.6C52.9,46.2,39,56.4,23.4,61.9C7.8,67.4,-9.5,68.2,-25.4,63C-41.3,57.8,-55.8,46.6,-64.1,31.8C-72.4,17,-74.5,-1.4,-69.8,-17.8C-65.1,-34.2,-53.6,-48.6,-39.8,-56.9C-26,-65.2,-10,-67.4,3.7,-71.9C17.4,-76.4,32.1,-61.4,44.7,-52.8Z",
    4: "M42.1,-50.3C54.9,-42.1,65.7,-29.3,70.1,-14.2C74.5,0.9,72.5,18.3,64.3,32.4C56.1,46.5,41.7,57.3,25.7,63.1C9.7,68.9,-7.9,69.7,-24.1,64.4C-40.3,59.1,-55.1,47.7,-63.7,32.7C-72.3,17.7,-74.7,-0.9,-70.2,-17.6C-65.7,-34.3,-54.3,-49.1,-40.6,-57.1C-26.9,-65.1,-10.9,-66.3,2.4,-69.3C15.7,-72.3,29.3,-58.5,42.1,-50.3Z"
  };

  const path = blobPaths[variant] || blobPaths[1];

  return (
    <svg
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        width: size,
        height: size,
        position: 'absolute',
        ...style
      }}
    >
      <path
        fill={color}
        opacity={opacity}
        d={path}
        transform="translate(100 100)"
      />
    </svg>
  );
};

export default OrganicBlob;
